// extracted by mini-css-extract-plugin
export default {"root":"mvi9NeQZSk","edgeDetector":"hcB8NstMaj","edgeDetector_horizontal":"xU6YqH3oMn","edgeDetector_vertical":"jl_UCCaP6I"};